import React, { useLayoutEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import About from "./pages/about/About";
import Apply from "./pages/apply/Apply";
import Dashboard from "./pages/dashboard/Dashboard";
import WorkProcess from "./pages/home/components/WorkProcess";
import Home from "./pages/home/Home";
import Kyc from "./pages/kyc/Kyc";
import Staking from "./pages/staking/Staking";
import Stats from "./pages/stats/Stats";
import "./style.scss";
function App() {
	const Wrapper = ({ children }) => {
		const location = useLocation();
		useLayoutEffect(() => {
			document.documentElement.scrollTo(0, 0);
		}, [location.pathname]);
		return children;
	};

	return (
		<>
			<BrowserRouter>
				<Wrapper>
					<Header />
					<Routes>
						<Route path="/" element={<Home />} />
					</Routes>
					<Routes>
						<Route path="/about" element={<About />} />
					</Routes>
					<Routes>
						<Route
							path="/kyc"
							element={
								<>
									<Kyc />
									<WorkProcess />
								</>
							}
						/>
					</Routes>
					<Routes>
						<Route path="/dashboard" element={<Dashboard />} />
					</Routes>
					<Routes>
						<Route path="/stats" element={<Stats />} />
					</Routes>
					<Routes>
						<Route path="/staking" element={<Staking />} />
					</Routes>
					<Footer />
					<Routes>
						<Route path="/apply" element={<Apply />} />
					</Routes>
				</Wrapper>
			</BrowserRouter>
		</>
	);
}

export default App;
